"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apply_service_const_1 = __importDefault(require("./apply_service_const"));
var ApplyServiceUtils = /** @class */ (function () {
    function ApplyServiceUtils() {
    }
    /**
     * @param inputNumberStr
     */
    ApplyServiceUtils.isApplyInputAgency = function (inputNumberStr) {
        return !ApplyServiceUtils.isNotApplyInputAgency(inputNumberStr);
    };
    /**
     * @param inputNumberStr
     */
    ApplyServiceUtils.isNotApplyInputAgency = function (inputNumberStr) {
        var inputNumber = Number(inputNumberStr);
        if (isNaN(inputNumber)) {
            inputNumber = 0;
        }
        return inputNumber === 0;
    };
    /**
     * なんのサービスも申し込んでいない場合に、Trueを返却。
     * @param contractDocument
     */
    ApplyServiceUtils.isNotApplyAnyService = function (contractDocument) {
        return (!contractDocument['applyInfoApplyService'] ||
            !contractDocument['applyInfoApplyService'].length);
    };
    /**
     * 機能訓練の商談オブジェクトを利用するか？
     * @param contractDocument
     */
    ApplyServiceUtils.isUseKobetuOpportunity = function (contractDocument) {
        if (ApplyServiceUtils.isNotApplyAnyService(contractDocument)) {
            return false;
        }
        if (contractDocument['applyInfoApplyService'].includes(apply_service_const_1.default.KOBETSU) &&
            contractDocument['applyInfoApplyService'].includes(apply_service_const_1.default.ORAL_CARE)) {
            var kobetuDateTime = Date.parse(contractDocument['applyInfoKinoKunrenStartDate']);
            var oralDateTime = Date.parse(contractDocument['applyInfoOralCareSstartDate']);
            return kobetuDateTime <= oralDateTime;
        }
        return contractDocument['applyInfoApplyService'].includes(apply_service_const_1.default.KOBETSU);
    };
    /**
     * Basic／Standard／Upgrade／ENTRY／Medium／Professionalの商談連携をするかチェックする
     * @param contractDocument
     */
    ApplyServiceUtils.isMainPlanCheck = function (contractDocument) {
        if (ApplyServiceUtils.isNotApplyAnyService(contractDocument)) {
            return false;
        }
        if (contractDocument['applyInfoApplyService'].includes(apply_service_const_1.default.BASIC) ||
            contractDocument['applyInfoApplyService'].includes(apply_service_const_1.default.STANDARD) ||
            contractDocument['applyInfoApplyService'].includes(apply_service_const_1.default.UPGRADE_TO_STANDARD) ||
            contractDocument['applyInfoApplyService'].includes(apply_service_const_1.default.OLD_STANDARD) ||
            contractDocument['applyInfoApplyService'].includes(apply_service_const_1.default.ENTRY) ||
            contractDocument['applyInfoApplyService'].includes(apply_service_const_1.default.MEDIUM) ||
            contractDocument['applyInfoApplyService'].includes(apply_service_const_1.default.PROFESSIONAL) ||
            contractDocument['applyInfoApplyService'].includes(apply_service_const_1.default.UPGRADE)) {
            return true;
        }
        return false;
    };
    /**
     * モーションAIの商談連携をするかチェックする
     * @param contractDocument
     */
    ApplyServiceUtils.isOptionalPlanCheck = function (contractDocument) {
        if (ApplyServiceUtils.isNotApplyAnyService(contractDocument)) {
            return false;
        }
        if (contractDocument['applyInfoApplyService'].includes(apply_service_const_1.default.MOTION_AI)) {
            return true;
        }
        return false;
    };
    /**
     * Ekycを必要とするプランは、Trueを返却する。
     * @param contractDocument
     */
    ApplyServiceUtils.isEkycCheck = function (contractDocument) {
        if (ApplyServiceUtils.isNotApplyAnyService(contractDocument)) {
            return false;
        }
        if (contractDocument['applyInfoApplyService'].includes(apply_service_const_1.default.STANDARD) ||
            contractDocument['applyInfoApplyService'].includes(apply_service_const_1.default.UPGRADE_TO_STANDARD) ||
            contractDocument['applyInfoApplyService'].includes(apply_service_const_1.default.OLD_STANDARD) ||
            contractDocument['applyInfoApplyService'].includes(apply_service_const_1.default.ENTRY) ||
            contractDocument['applyInfoApplyService'].includes(apply_service_const_1.default.MEDIUM) ||
            contractDocument['applyInfoApplyService'].includes(apply_service_const_1.default.PROFESSIONAL) ||
            contractDocument['applyInfoApplyService'].includes(apply_service_const_1.default.UPGRADE) ||
            contractDocument['applyInfoApplyService'].includes(apply_service_const_1.default.ADDITIONAL_TABLET)) {
            return true;
        }
        return false;
    };
    return ApplyServiceUtils;
}());
exports.default = ApplyServiceUtils;



//////////////////
// WEBPACK FOOTER
// ./common/src/constrains/contract_form/apply_service_utils.ts
// module id = moaq
// module chunks = 1